<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Urlopy</span>
        <h3 class="page-title">Moje urlopy</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button theme="success"
                  @click.prevent="$router.push('/urlopy/dodaj')">
          <i class="material-icons">add</i>
          Dodaj urlop
        </d-button>
        <d-button
          class="ml-2"
          style="width: 175px;"
          theme="info"
          @click.prevent="openModal">
          <i class="material-icons">book_online</i>
          Pobierz raport
        </d-button>
      </d-col>
    </d-row>
    <d-row
      v-if="loaded"
      style="width: 100%;"
      class="d-flex ml-0 mb-3 page-filters">
      <validation-observer
        ref="holidays-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <div :class="{ 'form-control': true, 'is-select': true }">
          <v-select
            :options="types"
            v-model="filters.type_id"
            :reduce="type => type.id"
            placeholder="Sortuj według typu urlopu"
            label="id">
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.name }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.name }}
              </div>
            </template>
          </v-select>
        </div>
        <v-select
          style="width: 360px;"
          class="ml-2"
          :options="statusFilter"
          v-model="filters.status"
          placeholder="Sortuj według statusu"
          :searchable="false"
          label="text">
        </v-select>
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>
        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>
    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0">Start urlopu</th>
          <th scope="col" class="border-0">Koniec urlopu</th>
          <th scope="col" class="border-0">Rodzaj</th>
          <th scope="col" class="border-0">Zgodność z planem urlopowym</th>
          <th scope="col" class="border-0">Status</th>
          <th scope="col" class="border-0">Akcje</th>
        </tr>
        </thead>
        <tbody v-if="loaded">
        <tr
          v-for="(holiday, index) of holidays"
          :key="'user-' + index">
          <td class="align-middle" style="white-space: nowrap" :style="holiday.type_id === 3 ? (holiday.plan_id > 0 ? '' : (holiday.plan_id === 0 ? 'color: #c4183c' : '')) : ''">
            {{ holiday.date_start }}
          </td>
          <td class="align-middle" style="white-space: nowrap" :style="holiday.type_id === 3 ? (holiday.plan_id > 0 ? '' : (holiday.plan_id === 0 ? 'color: #c4183c' : '')) : ''">
            {{ holiday.date_end }}
          </td>
          <td class="align-middle" :style="holiday.type_id === 3 ? (holiday.plan_id > 0 ? '' : (holiday.plan_id === 0 ? 'color: #c4183c' : '')) : ''">
            {{ holiday.type_name }}
          </td>
          <td class="align-middle" :style="holiday.type_id === 3 ? (holiday.plan_id > 0 ? 'color: #17c671;' : (holiday.plan_id === 0 ? 'color: #c4183c' : '')) : ''">
            {{ holiday.type_id === 3 ? (holiday.plan_id > 0 ? 'TAK' : (holiday.plan_id === 0 ? 'NIE' : '')) : ''}}
          </td>
          <td class="align-middle" :style="holiday.status === 'ACCEPTED' ? 'color: #17c671;' : (holiday.status === 'REJECTED' ? 'color: #ad1535;' : (holiday.status === 'NEW' ? '' : 'color: #ffb400;'))">
            {{ holiday.status === 'ACCEPTED' ? 'Zaakceptowany' : (holiday.status === 'REJECTED' ? 'Odrzucony' : (holiday.status === 'NEW' ? 'Oczekuje akceptacji' : 'Anulowany')) }}
          </td>
          <td
            class="align-middle"
            style="width: 150px;">
            <d-button
              theme="info"
              @click.prevent="$router.push('/urlopy/edycja/' + holiday.id)"
              class="mr-2"
              title="Szczegóły urlopu">
              <i class="material-icons">person_search</i>
            </d-button>
            <d-button
              :disabled="holiday.status !== 'NEW'"
              :theme="holiday.status === 'CANCELLED' ? 'warning' : 'light'"
              @click.prevent="cancelHoliday(holiday.id)"
              title="Anuluj urlop">
              <i class="material-icons">{{ holiday.status !== 'CANCELLED' ? 'settings_backup_restore' : 'done'}}</i>
            </d-button>
          </td>
        </tr>
        <tr v-if="holidays.length === 0">
          <td
            colspan="5"
            class="text-center">
            Brak urlopów do wyświetlenia&hellip;
          </td>
        </tr>
        </tbody>
      </table>
      <holidays-children-report
        :key="modalKey"
        :close-modal="closeModal"
        :show-modal="showModal"
        :role="this.userData.role"
        :label="'Wygeneruj raport urlopowy'"/>
      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>
    <pagination :meta-data="paginationMetaData" />
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from '../../utils/FormUtils.js';
import HasFilters from '../../mixins/HasFilters.vue';
import HasPagination from '../../mixins/HasPagination.vue';
import ListUtils from '../../utils/ListUtils.js';
import Pagination from '../../components/common/Pagination.vue';
import HolidaysChildrenReport from './HolidaysChildrenReport';

export default {
  name: 'holidays',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    HolidaysChildrenReport,
    'pagination': Pagination
  },
  computed: {
    userData () {
      return this.$store.getters.getAccount
    },
    statusFilter () {
      return [
        {
          text: 'Zaakceptowane',
          value: 'ACCEPTED'
        },
        {
          text: 'Anulowane',
          value: 'CANCELLED'
        },
        {
          text: 'Oczekuje akceptacji',
          value: 'NEW'
        }
      ];
    },
  },
  data() {
    return {
      types: [],
      holidays: [],
      users: [],
      loaded: false,
      loadError: false,
      removeInProgress: false,
      showModal: false,
      modalKey: 0,
      filters: {
        search: '',
        status: '',
        type_id: ''
      }
    };
  },
  mounted () {
    this.loadFilteredData();
    this.getUsersList();
    this.getHolidaysTypes();
  },
  methods: {
    userAccountGet () {
      this.$store.dispatch('userAccountGet')
    },
    openModal () {
      this.modalKey += 1;
      this.showModal = true;
    },
    closeModal () {
      this.showModal = false;
      this.modalKey += 1;
    },
    getHolidaysTypes () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/holidays/types',
        outputKey: 'types',
      });
    },
    getUsersList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/items',
        outputKey: 'users',
      });
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let where = {
        type_id: this.filters.type_id
      };
      if (this.filters.status !== null && this.filters.status && this.filters.status.value) {
        where.status = this.filters.status.value;
      }
      ListUtils.loadItemsData(this, {
        endpoint: '/holidays/items?page=' + this.currentPage,
        listField: 'holidays',
        pagination: true,
        params: {
          where
        }
      });
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['holidays-filters-form'], this.debouncedLoadFilteredData);
    },
    clearFilters () {
      this.loaded = false;
      this.loadError = false;
      this.filters = {
        search: '',
        status: '',
        type_id: ''
      };

      this.loadFilteredData();
      this.$bus.$emit('view-filters-reset');
    },
    cancelHoliday (holidayID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/holidays/cancel/',
        id: holidayID,
        successTitle: 'Anulowano urlop',
        successText: 'Wybrany urlop został anulowany',
        confirmTitle: 'Czy na pewno chcesz anulować urlop?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        confirmButtonText: 'Potwierdź',
        errorText: 'Anulowanie urlopu nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
  .vs__dropdown-option {
    white-space: normal;
  }
</style>

